module.exports = __webpack_public_path__ + "media/images/vector/vector3-c9404e83b6cfebf7883b3c765a97ae77.png";